// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e41ab0d3","667":"64dc71b2","977":"49e251a2"}[chunkId] + ".chunk.js";
};